var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 903.4 1080",
    style: {
      enableBackground: "new 0 0 903.4 1080"
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    className: "svg-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:#08203E;}\n\t.st3{fill:#557C93;}\n\t.st4{fill:url(#SVGID_00000177480866864670314110000006033770959733083277_);}\n\t.st5{fill:#43413F;}\n\t.st6{fill:#BCBEC0;}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 458.4074,
    y1: 976.2166,
    x2: 458.4074,
    y2: 66.4905
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#557C93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#08203E"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M816.4,826.7v6.6v15.8v53.3c0,40.7-33,73.8-73.8,73.8h-69.1H667V826.7H816.4z M572.5,826.7v149.5h-24H305.3 h-41.2h-89.9c-40.7,0-73.8-33-73.8-73.8V140.3c0-40.7,33-73.8,73.8-73.8h568.4c40.7,0,73.8,33,73.8,73.8v254.2v174.1v139.8v24H667 V582.9h-94.4v149.5H423.1v94.3H572.5z M212.1,289.9h436.3v-84.5H212.1V289.9z M212.1,471.1h274.2v-84.5H212.1V471.1z M378,567.9 H212.1v84.5H378V567.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/Logo_small.4aba1ce814a392a7431bc6e916f406f1.svg";
export { ForwardRef as ReactComponent };